import { Stack } from "@/Components/v2/atoms/Stack";
import { Typography } from "@/Components/v2/atoms/Typography";

interface ResultDisplayProps {
  result: number | string;
  title: string;
  subTitle?: string;
}

const ResultDisplay: React.FC<ResultDisplayProps> = ({ title, result, subTitle }) => {
  return (
    <Stack>
      <Typography variant="body1" color="textPrimary" mt={2}>
        {title}
      </Typography>
      <Typography variant="h5" fontWeight={600} color="textPrimary">
        {result}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        {subTitle}
      </Typography>
    </Stack>
  );
};

export default ResultDisplay;
